<template>
  <section class="box grey left-box-sizing text-left">
    <!-- box header -->
    <div class="header">
      <span class="step mx-2 mx-md-4">
        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.43657 12.0857C4.89231 12.3821 4.19643 12.2821 3.75954 11.8041L0.361296 8.0867C-0.152713 7.5244 -0.113573 6.65189 0.448719 6.13788C1.01101 5.62387 1.88352 5.66301 2.39753 6.2253L4.86533 8.92491L13.6901 0.857877C14.2524 0.343869 15.125 0.383009 15.639 0.945301C16.153 1.50759 16.1138 2.38011 15.5515 2.89411L5.70971 11.8908C5.62495 11.9683 5.53314 12.0332 5.43657 12.0857Z" fill="white"/>
        </svg>
      </span>
      <h2>
        <span style="color: #909090;">Delivery Information</span>
        <small class="mt-md-1">
          <b>{{ fname }}{{ ` ${lname}` }}</b>,
          +91{{ phone }}{{ `, ${email}` }}
        </small>
      </h2>
    </div>
  </section>
</template>

<script>
export default {
  name: "DeliveryDisabled",
  props: ["fname", "lname", "phone", "email", "course"],
}
</script>

<style scoped>
  .box {
    width: 100%;
  }
  .box > .header > .step {
    color:#fff;
    border-radius: 1000px;
    background: #9FC349;
    height: 36px;
    width: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .box > .content {
    overflow: hidden;
    /* min-height: 200px; */
  }

  .box > .content .form {
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .input-group {
    position: relative;
  }

  .input-group > .label {
    position: absolute;
  }
  .input-group > .text:hover, .label:hover {
    cursor: pointer;
  }

  .text {
    outline: none;
    padding: 10px;
    border-radius: 4px;
    border: solid 1px #A0A0A0;
    /* width: 100%; */
  }

  .label {
    padding: 11px;
    top: 0;
    left: 0;
    transition: all 0.5s;
    color: #A0A0A0;
    white-space: nowrap;
  }

  .text:focus {
    border: solid 1px #F36F2E;
  }

  .text:focus ~ .label {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
    color: #F36F2E;
    
    transition: all 0.5s;
  }

  .filled {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
  }
</style>